import React from 'react';
import { Tooltip, Space } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import TOOLTIP_TEXT from './tooltip.json'; // Make sure this path is correct

/**
 * HeaderWithInfo - Displays a label with a ? icon and tooltip
 * @param {string} label - The row header text (e.g., "Installation Date: Lifter")
 */
const HeaderWithInfo = ({ label }) => {
  const tip = TOOLTIP_TEXT[label] ?? 'No description available.';

  return (
    <Space size={4} align="center">
      <span>{label}</span>
      <Tooltip title={tip} placement="right">
        <QuestionCircleOutlined
          style={{
            fontSize: '14px',
            color: '#1890ff',
            cursor: 'help',
          }}
        />
      </Tooltip>
    </Space>
  );
};

export default HeaderWithInfo;